import React from 'react';
import PropTypes from 'prop-types'
import Select from 'react-select'
import { useFormContext, useController } from "react-hook-form";

const FormSelect = ({ name, options, handleChange, getOptionLabel, getOptionValue }) => {
  const { control } = useFormContext()
  const {
    field: { value, onChange, ref, ...inputProps },
  } = useController({ name, control })

  const onChangeExtend = onChange => option => {
    if(option) {
      const value = getOptionValue(option)
      onChange(value)
      handleChange(name, value);
    } else {
      onChange('')
      handleChange(name, '');
    }
  }

  return (
    <Select
          inputRef={ref}
          isClearable={true}
          value={options.find(option => getOptionValue(option) === value)}
          options={options}
          styles={{
            control: (provided) => ({
              ...provided,
              borderRadius: '0.65rem',
              borderColor: '#e4e6ef',
              fontWeight: 500,
              fontSize: '1.1rem',
              height: '42px',
            })
          }}
          getOptionLabel={getOptionLabel}
          getOptionValue={getOptionValue}
          onChange={onChangeExtend(onChange)}
          {...inputProps}
        />
  )
}

FormSelect.defaultProps = {
  handleChange: () => {},
}

FormSelect.propTypes = {
  onChange: PropTypes.func,
  getOptionLabel: PropTypes.func.isRequired,
  getOptionValue: PropTypes.func.isRequired,
  handleChange: PropTypes.func,
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
}

export default FormSelect;
